import { IMAGES } from "../../data/site";
import { MessageCircle, ShieldCheck, Truck } from "lucide-react";

const POINTS = [
    {
        icon: MessageCircle,
        title: "Rapporto diretto",
        text: "Parli sempre con la stessa persona. Nessun bot, nessun call center: consigli veri da chi conosce ogni modello.",
    },
    {
        icon: ShieldCheck,
        title: "Onestà prima di tutto",
        text: "Se un paio non vale il prezzo, te lo diciamo. La fiducia si costruisce una vendita alla volta.",
    },
    {
        icon: Truck,
        title: "Spedizione ovunque",
        text: "Vendiamo online e spediamo dove vuoi. Ti aggiorniamo passo dopo passo fino alla consegna.",
    },
];

export const BrandStory = () => {
    return (
        <section id="chi-siamo" data-testid="brand-story-section" className="py-24 sm:py-32 bg-[#0A0A0A]">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <div>
                        <p className="text-[#E60000] font-bold uppercase tracking-[0.3em] text-sm mb-4">Chi siamo</p>
                        <h2 data-testid="brand-story-title" className="text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white leading-tight">
                            Perché scegliere<br />Hype Sneakers 21?
                        </h2>
                        <p className="mt-6 text-neutral-300 leading-relaxed max-w-lg">
                            Perché qui non sei un numero d'ordine. Ogni richiesta parte da una
                            conversazione vera: capiamo cosa cerchi, ti consigliamo senza giri di
                            parole e ti convinciamo con i fatti, non con lo spam. È così che i
                            nostri clienti tornano.
                        </p>
                        <div className="mt-10 space-y-6">
                            {POINTS.map((p, i) => (
                                <div key={p.title} data-testid={`brand-point-${i + 1}`} className="flex gap-4">
                                    <div className="shrink-0 h-11 w-11 flex items-center justify-center border border-[#262626] bg-[#141414]">
                                        <p.icon className="h-5 w-5 text-[#E60000]" />
                                    </div>
                                    <div>
                                        <h3 className="text-white font-semibold uppercase tracking-tight">{p.title}</h3>
                                        <p className="text-sm text-neutral-400 mt-1 leading-relaxed">{p.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="relative">
                        <div className="absolute -inset-4 border border-[#E60000]/30 pointer-events-none" />
                        <img
                            src={IMAGES.story}
                            alt="Selezione di sneakers"
                            data-testid="brand-story-image"
                            className="w-full aspect-[4/5] object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
